/* src/app/shared/components/flow-card-v2/flow-card-v2.component.scss */
:host {
  display: block;
  width: 100%;
}
.flow-card {
  border: 1px solid #e4e4e7;
  border-radius: 12px;
  background: #ffffff;
}
.flow-card-expanded {
  border-color: #4568d0;
}
.flow-card-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  border-radius: 11px 11px 0 0;
}
.flow-card-header:has(+ .flow-card-body[hidden]),
.flow-card-header:has(+ .flow-card-body:empty) {
  border-radius: 11px;
}
.flow-card-header-clickable {
  cursor: pointer;
}
.flow-card-header-clickable:focus-visible {
  outline: 2px solid var(--border-focus, #4c6ef5);
  outline-offset: -2px;
}
.flow-card-title-group,
.flow-card-title-row,
.flow-card-actions,
.flow-card-chevron {
  display: flex;
  align-items: center;
}
.flow-card-title-group {
  flex: 1 1 auto;
  min-width: 0;
  gap: 16px;
}
.flow-card-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.flow-card-icon {
  width: 32px;
  height: 32px;
}
.flow-card-icon-boxed {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #f4f4f5;
}
.flow-card-icon-boxed .flow-card-icon {
  width: 20px;
  height: 20px;
}
.flow-card-title-icon {
  width: 20px;
  height: 20px;
}
.flow-card-chevron img {
  width: 20px;
  height: 20px;
}
.flow-card-checkbox,
.flow-card-icon-wrapper,
.flow-card-icon,
.flow-card-title-icon,
.flow-card-actions,
flow-badge,
.flow-card-disabled-text,
.flow-card-chevron {
  flex-shrink: 0;
}
.flow-card-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.flow-card-title-row {
  gap: 8px;
  min-width: 0;
}
.flow-card-title,
.flow-card-subtext {
  margin: 0;
}
.flow-card-title {
  min-width: 0;
  overflow: hidden;
  color: #18181b;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.flow-card-subtext {
  color: #71717a;
}
.flow-card-actions {
  gap: 12px;
}
.flow-card-disabled-text {
  color: #a1a1aa;
  white-space: nowrap;
}
.flow-card-chevron {
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
}
.flow-card-chevron img {
  transition: transform 0.2s ease;
}
.flow-card-chevron-expanded img {
  transform: rotate(180deg);
}
.flow-card-body {
  border-top: 1px solid #e4e4e7;
  border-radius: 0 0 11px 11px;
}
.flow-card-body:empty {
  display: none;
}
/*# sourceMappingURL=flow-card-v2.component.css.map */
